import * as angular from "angular";
import {IController, IQService, ITimeoutService} from "angular";
import * as _ from "lodash"
import {SplitService} from "../../../commons/services/split-service.service";
import {DataSet} from "vis-data";
import {TasksService} from "../../../tasks/services/tasks-service.service";
import {BringozTimelineService} from "../../../commons/services/bringoz-timeline-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {ScheduleService} from "../../../schedule/services/schedule-service.service";

export class ReportsSisenceAgentsTimelineComponent implements IController {
  agents: any;
  tasks: any;
  date: string;
  isStack: boolean;
  colorByLate: boolean;
  selectedItemId: any;
  onViewService: Function;
  onRightClickTask: Function;

  private container: any;
  private vis: any;
  private rrule: any;
  private options: any;
  private timeline: any;
  private tableHeaderDivRef: any;
  private groupsDataSet: any;
  private purposeToSkillMap: any;
  private purposeToColor: any;
  private timeFormat: any;
  private shortDateFormat: any;
  private longDateFormat: any;
  private itemsDataSet: any;

  private colorPallet: any;

  /////////////////// ICONS ///////////////////
  private iconsUrl: any;
  private readonly $agentOnDutyIcon: any;
  private readonly $agentOffDutyIcon: any;
  private $routedRowIcon: any;
  private $GPSRowIcon: any;

  constructor(private $q: IQService, private confirmDialogService: ConfirmDialogService, private $filter, private splitService: SplitService, private commonsDialogService: CommonsDialogService,
              private $timeout: ITimeoutService, private tasksConstants, private moment, private scheduleService: ScheduleService,
              private bringozTimelineService: BringozTimelineService, private tasksService: TasksService,
              private leanPlanningConstants, private commonsConstants) {

    this.vis = require('vis-timeline');
    this.rrule = require('rrule');
    this.purposeToSkillMap = {
      Pickup: ['Delivery'],
      Dropoff: ['Delivery'],
      Operation: ['Merchandise', 'Order']
    };
    this.purposeToColor = tasksConstants.purposeToColor;
    const dateAndTimeConfig = this.splitService.getDateAndTimeConfig();
    this.timeFormat = dateAndTimeConfig.time;
    this.shortDateFormat = dateAndTimeConfig.date;
    this.longDateFormat = dateAndTimeConfig.long;

    this.iconsUrl = {
      onDuty: 'assets/images/icons/v2/on-duty.svg',
      offDuty: 'assets/images/icons/v2/off-duty.svg',
      routed: 'assets/images/icons/v2/route.svg',
      gps: 'assets/images/icons/v2/gps.svg'
    }

    this.$agentOnDutyIcon = document.createElement('IMG');
    this.$agentOnDutyIcon.setAttribute("src", this.iconsUrl.onDuty);
    this.$agentOnDutyIcon.classList.add('bringoz-icon');

    this.$agentOffDutyIcon = document.createElement('IMG');
    this.$agentOffDutyIcon.setAttribute("src", this.iconsUrl.offDuty);
    this.$agentOffDutyIcon.classList.add('bringoz-icon');

    this.$routedRowIcon = document.createElement('IMG');
    this.$routedRowIcon.setAttribute("src", this.iconsUrl.routed);
    this.$routedRowIcon.classList.add('bringoz-icon-small');

    this.$GPSRowIcon = document.createElement('IMG');
    this.$GPSRowIcon.setAttribute("src", this.iconsUrl.gps);
    this.$GPSRowIcon.classList.add('bringoz-icon-small');
  }

  $onInit() {
    this.colorPallet = _.concat(this.commonsConstants.colorPalletTwo, this.commonsConstants.colorPalletTwo);

    // create visualization
    this.container = document.getElementById('timeline');

    // Set Timeline
    this.groupsDataSet = new DataSet()
    this.itemsDataSet = new DataSet()

    // Set Options
    this.options = {
      // option groupOrder can be a property name or a sort function
      // the sort function must compare two groups and return a value
      //     > 0 when a > b
      //     < 0 when a < b
      //       0 when a == b
      groupOrder: (a, b) => {
        return a.value - b.value;
      },
      groupOrderSwap: (groupDragged, groupToSwap, groups) => {
        const value = groupDragged.value;
        groupDragged.value = groupToSwap.value;
        groupToSwap.value = value;
      },
      groupTemplate: (group) => {

        if (group.isGeo) {

          const geoName = document.createElement('span');
          geoName.classList.add("br-body-1");
          geoName.textContent = 'Passive (Actual)';
          // container1.classList.add("group-info-container");

          const mainContainerRoute = document.createElement('div');
          // mainContainerRoute.classList.add("group-route-container");
          const geoIcon = this.$GPSRowIcon.cloneNode(true);
          geoIcon.classList.add('white');
          mainContainerRoute.appendChild(geoIcon);
          mainContainerRoute.appendChild(geoName);
          return mainContainerRoute;
        }

        if (group.isItinerary) {

          const routeName = document.createElement('span');
          routeName.classList.add("br-body-1");
          routeName.textContent = 'Manual (Actual)';
          // container1.classList.add("group-info-container");

          const mainContainerRoute = document.createElement('div');
          // mainContainerRoute.classList.add("group-route-container");
          const routeIcon = this.$routedRowIcon.cloneNode(true);
          routeIcon.classList.add('white');
          mainContainerRoute.appendChild(routeIcon);
          mainContainerRoute.appendChild(routeName);
          return mainContainerRoute;
        }

        const container = document.createElement('div');
        container.classList.add("group-info-container");

        const mainContainer = document.createElement('div');
        mainContainer.classList.add("group-info-main-container");

        const imageContainer = document.createElement('div');
        imageContainer.classList.add("image-container");

        if (group.avatarUrl) {
          const agentImage = document.createElement("IMG");
          agentImage.setAttribute("src", group.avatarUrl);
          imageContainer.insertAdjacentElement('beforeend', agentImage);
        } else {
          const imageDiv = document.createElement('div');
          imageDiv.classList.add("agent-image-initials-div");
          const imageSpan = document.createElement("span");
          imageSpan.innerText = group.nameInitials;
          imageDiv.insertAdjacentElement('beforeend', imageSpan);
          imageContainer.insertAdjacentElement('beforeend', imageDiv);
        }

        const infoContainer = document.createElement('div');
        infoContainer.classList.add("info-container");

        const firstInfoRowContainer = document.createElement('div');
        firstInfoRowContainer.classList.add("info-row");

        const secondInfoRowContainer = document.createElement('div');
        secondInfoRowContainer.classList.add("info-row");

        const groupName = document.createElement('span');
        groupName.classList.add("br-body-1", "text-ellipsis", "font-weight-600");
        groupName.innerText = group.name;

        // const skill = document.createElement('span');
        // skill.classList.add("br-body-1", "margin-left-5");
        // skill.innerText = group.skills?.length ? group.skills[0] : '';

        const secondRowText = document.createElement('span');
        secondRowText.classList.add("br-body-1");
        secondRowText.textContent = 'Planned Route';

        firstInfoRowContainer.insertAdjacentElement('beforeend', groupName);
        // firstInfoRowContainer.insertAdjacentElement('beforeend', skill);
        firstInfoRowContainer.insertAdjacentElement('beforeend', group.agentStatus === 'OnDuty' ? this.$agentOnDutyIcon.cloneNode(true) : this.$agentOffDutyIcon).cloneNode(true);

        secondInfoRowContainer.insertAdjacentElement('beforeend', secondRowText);

        infoContainer.insertAdjacentElement('beforeend', firstInfoRowContainer);
        infoContainer.insertAdjacentElement('beforeend', secondInfoRowContainer);

        container.insertAdjacentElement('beforeend', infoContainer);
        container.insertAdjacentElement('beforeend', imageContainer);
        container.insertAdjacentElement('beforeend', infoContainer);
        // container.appendChild(groupName);
        mainContainer.insertAdjacentElement('beforeend', container);

        return mainContainer;
      },
      snap: (date, scale, step) => {
        const fifteenMinutes = 60 * 1000; // ticks of 15 minutes
        return Math.round(date / fifteenMinutes) * fifteenMinutes;
      },
      orientation: 'top',
      // editable: true,
      // selectable: true,
      editable: false,
      xss: {
        disabled: true,
        // filterOptions: {
        //   whiteList: { p: ['class', 'data-from-template'], div: 'class' },
        // },
      },
      verticalScroll: true,
      zoomKey: 'ctrlKey',
      width: '100%',
      height: '100%',
      margin: {
        item: 5
      },
      stack: !!this.isStack,
      // stackSubgroups: false,
      tooltip: {
        followMouse: true
      },
      // maxMinorChars: 5,
      start:  this.moment(this.date).startOf('day'),
      end:  this.moment(this.date).endOf('day'),
      min: this.moment(this.date).startOf('day'),
      max: this.moment(this.date).endOf('day'),
      zoomMin: 1080000 // Zoom In Max 5 Mins
      // zoomMax: 18800000 // Zoom Out Max 1 Hour,
    };

    this.timeline = new this.vis.Timeline(this.container, [], this.options);
    this.timeline.itemSet.groupHammer.off('tap');

    // Set Table Actions
    const topElementRef = this.timeline.body.dom.top;
    topElementRef.style = 'left: 0px';
    this.tableHeaderDivRef = document.createElement("div");
    this.tableHeaderDivRef.classList.add("resources-list-header-container");

    // var addResourceButton = document.createElement('md-button');
    // addResourceButton.classList.add("md-raised", "md-accent");
    // addResourceButton.innerHTML = '+ ' +  $filter('translate')('Add Resource');
    // tableHeaderDivRef.appendChild(addResourceButton);

    topElementRef.before(this.tableHeaderDivRef);

    // Set Timeline
    this.timeline.setGroups(this.groupsDataSet);
    this.timeline.setItems(this.itemsDataSet);

    // Init Groups
    this._initTimelineData(this.agents);

    // Init Tasks
    const itemsToAdd = this._getTasksItemsData(this.tasks);

    if (itemsToAdd.length) {
      this.itemsDataSet.add(itemsToAdd);
    }
    // Click Event
    this.timeline.on('click', (properties) => {
      if (properties.what === "group-label" && !properties.group.includes("routes-")) {
        this._toggleGroupRoutes(properties.group);
      }
    });

    // Double Click Event
    this.timeline.on('doubleClick', (properties) => {
      if (_.get(properties, 'item')) {
        const item = this.itemsDataSet.get(properties.item);
        if (_.get(item, 'serviceId')) {
          this.onViewService({id: item.serviceId});
        }
      }
    });

    // Right Click Event
    this.timeline.on('contextmenu', (properties) => {
      if (_.get(properties, 'item')) {
        const event = properties.event;
        const item = this.itemsDataSet.get(properties.item);
        this._onClicked().then(() => {
          this.onRightClickTask({task: item.ref, event: event});
        })
      }
      properties.event.preventDefault();
    });
  }

  $onChanges(changes: angular.IOnChangesObject) {

    if (changes.agents && !changes.agents.isFirstChange()) {
      this.groupsDataSet.clear();
      this.groupsDataSet.add(this._getGroupsData(this.agents));
      this.$timeout(300).then(() => {
        this._setExpandedGroupsRoutes();
      })
    }

    if (
      (changes.tasks && !changes.tasks.isFirstChange()) ||
      (changes.colorByLate && !changes.colorByLate.isFirstChange())
    ) {
      // this._clearTasksItems();
      this.itemsDataSet.clear();

      // Init Tasks
      const itemsToAdd = this._getTasksItemsData(this.tasks);

      if (itemsToAdd.length) {
        this.$timeout(500).then(() => {
          this.itemsDataSet.add(itemsToAdd);
        })
      }
    }


    if (changes.selectedItemId && !changes.selectedItemId.isFirstChange()) {
      const selectedTask = this._getSelectedItem(this.selectedItemId);
      if (selectedTask) {
        this.timeline.setSelection(selectedTask.id);
      }
    }

    if (changes.date && !changes.date.isFirstChange()) {
      const start = this.moment(this.date).startOf('day');
      const end = this.moment(this.date).endOf('day');


      this.options.min = start;
      this.options.max = end;
      this.timeline.setOptions(this.options);
      this.timeline.setWindow(start.toDate(), end.toDate());
      // onFit();
    }

    if (changes.isStack && !changes.isStack.isFirstChange()) {
      this.options.stack = !!this.isStack;
      this.timeline.setOptions(this.options);
    }

  }


  // ******************************
  //        Public methods
  // ******************************

  public onFit() {
    // var ids = _getRoutesItemIds();
    this.timeline.fit();
  }

  private onZoom(isZoomIn) {
    isZoomIn ? this.timeline.zoomIn(0.5) : this.timeline.zoomOut(0.5);
  }

  // ******************************
  //        Private methods
  // ******************************

  private _getGroupsData(agents) {

    const routesGroup = [];
    const geoGroups = [];
    const itineraryGroups = [];

    // _.forEach(agents, (a, index) => {
    //   geoGroups.push(this._getGeoGroup(a, index));
    //   agentsGroups.push(this._getItineraryGroup(a, index));
    //   routesGroup.push(this._getRoutesGroup(a, index));
    // })

    _.forEach(agents, (a, index) => {
      routesGroup.push(this._getRoutesGroup(a, index));
      geoGroups.push(this._getGeoGroup(a, index));
      itineraryGroups.push(this._getItineraryGroup(a, index));
    })

    return _.concat(routesGroup, geoGroups, itineraryGroups);
  }


  private _getTranslatedResourceSkills(requiredSkills, isFirstLetterOnly) {
    return _.map(requiredSkills, (s) => {
      return this._getTranslatedSkill(s, isFirstLetterOnly)
    });
  }

  private _getTranslatedSkill(skill, isFirstLetterOnly) {
    const text = this.$filter('translate')('SKILLS.' + skill);
    return isFirstLetterOnly ? text.charAt(0) : text;
  }

  private _getTasksItemsData(tasks) {

    // const filteredTasks = _.filter(tasks, (t) => {
    //   const agent = _.find(this.agents, (a) => {
    //     return _.isEqual(t.agentId, a.id);
    //   })
    //   return !!agent;
    // })

    const geoTasks = [];
    const itineraryTasks = [];
    const routeAnalysisTasks = [];

    _.forEach(tasks, (t) => {
      if (t.analysis && t.agentId) {
        const taskCopy = angular.copy(t);
        taskCopy.routeIndex = _.get(t, 'routeAnalysis.daySequence');
        taskCopy.routeEta = _.get(t, 'routeAnalysis.eta');
        taskCopy.routeEtd = _.get(t, 'routeAnalysis.etd');
        _.unset(taskCopy, 'analysis.geofenceEventDataSegment');
        _.unset(taskCopy, 'routeAnalysis');

        itineraryTasks.push(taskCopy);
      }
      if ((t.analysis?.geofenceEventDataSegment?.startEntry || t.analysis?.geofenceEventDataSegment?.endEntry) && t.agentId) {
        const taskCopy = angular.copy(t);
        taskCopy.routeIndex = _.get(t, 'routeAnalysis.daySequence');
        taskCopy.routeEta = _.get(t, 'routeAnalysis.eta');
        taskCopy.routeEtd = _.get(t, 'routeAnalysis.etd');

        // Fake geoExitEvent
        if (!_.get(t, 'analysis.geofenceEventDataSegment.endEntry') && !!_.get(t, 'agentDepartureTime')) {
          if (!taskCopy.analysis) {
            taskCopy.analysis = {};
          }
          if (!taskCopy.analysis.geofenceEventDataSegment) {
            taskCopy.analysis.geofenceEventDataSegment = {};
          }
          _.set(taskCopy, 'analysis.geofenceEventDataSegment.endEntry',{
            timeStamp: this.moment(t.agentDepartureTime).add(7, 'minute').add(30, 'second')
          });
        }

        _.unset(taskCopy, 'routeAnalysis');

        geoTasks.push(taskCopy);
      }
      if (t.routeAnalysis && t.agentId) {
        const taskCopy = angular.copy(t);
        _.unset(taskCopy, 'analysis');
        routeAnalysisTasks.push(taskCopy);
      }
    })

    return _.map(_.concat(geoTasks, itineraryTasks, routeAnalysisTasks), (task) => {
      const isGeoTask = !!task.analysis && (task.analysis.geofenceEventDataSegment?.startEntry || task.analysis?.geofenceEventDataSegment?.endEntry) && task.agentId;
      const isItineraryTask = !!task.analysis && !(task.analysis.geofenceEventDataSegment?.startEntry || task.analysis.geofenceEventDataSegment?.endEntry);
      const isRouteTask = !task.analysis;

      const analysisRef = task.routeAnalysis || task.analysis;
      const groupId = task.agentId;
      let taskIndex = task.routeIndex || analysisRef.daySequence;

      const taskServiceTime = _.get(analysisRef, 'serviceTime');
      const isBundle = _.isEqual(task.taskType, 'BundledStopover');

      let taskEta = isGeoTask ? (analysisRef.geofenceEventDataSegment?.startEntry?.timeStamp || task.agentArrivalTime || _.get(analysisRef, 'eta')) : (isItineraryTask ? (task.agentArrivalTime || _.get(analysisRef, 'eta')) : _.get(analysisRef, 'eta'));
      const taskEtd = isGeoTask ? (analysisRef.geofenceEventDataSegment?.endEntry?.timeStamp || task.agentDepartureTime) : (isItineraryTask ? (task.agentDepartureTime || _.get(analysisRef, 'eta') || (taskEta + taskServiceTime)) : (_.get(analysisRef, 'etd') || (taskEta + taskServiceTime)));
      const isPoint = _.isEqual(task.taskType, 'Internal') || !taskEtd;


      const relations = _.get(task, 'relations', []);
      const taskPurpose = task.taskSpec.purpose;
      const taskNotBefore = _.get(task, 'taskSpec.notBefore');
      const isLate =  isGeoTask ? (taskEtd > task.routeEtd) : (isItineraryTask ? (!!task.agentDepartureTime ? (task.agentDepartureTime > task.routeEtd) :
        (!!task.agentArrivalTime ? (task.agentArrivalTime > taskEta) : (taskEta > task.routeEta))) : undefined)

      const taskEtaWindow = this.$filter('timeWindow')({notBefore: taskEta, notAfter: taskEtd});
      // const color = isItineraryTask ?
      //   (this.colorByLate ? (!!task.routeEtd && (task.routeEtd < taskEtd) ? '#D52424' : '#0BBBE6') : this.CommonsService.getColorById(task.agentId)) :
      //   (this.colorByLate ? '#616161' : this.CommonsService.getColorById(task.agentId));


      const groupIndex = _.findIndex(this.agents, (a: any) => {
        return a.id === groupId;
      })
      const color = (isItineraryTask || isGeoTask) ?
        (this.colorByLate ? (isLate ? '#F9585A' : '#69C869') : this.colorPallet[groupIndex]) :
        (this.colorByLate ? '#616161' : this.colorPallet[groupIndex]);

      let style = `color: white; background: ${color}`;

      if (isBundle) {
        style += ' box-shadow: 2px -2px 0px ;';
      }

      let className = isPoint ? 'internal' : (isBundle ? 'bundle' : 'task');
      className += isGeoTask ? ' geo' : (isItineraryTask ? ' itinerary' : ' route');

      return {
        ref: task,
        id: isGeoTask ? `geo-${task.id}` : (isItineraryTask ? `itinerary-${task.id}` : task.id),
        status: task.status,
        // id: route.rid + task.id,
        start: this.moment(taskEta),
        end: taskEtd ? this.moment(taskEtd).subtract(10, 'second') : undefined,
        startTime: this.moment(taskEta),
        endTime: this.moment(taskEtd),
        purpose: taskPurpose,
        taskIdList: _.get(task, 'taskIdList'), // For Bundle Only
        point: isPoint ? 'point' : 'box',
        taskType: task.taskType,
        serviceId: task.serviceId,
        serviceIds: task.bundleServiceIdList,
        // group: groupId,
        group: isGeoTask ? `geo-${task.agentId}` : (isItineraryTask ? `itinerary-${task.agentId}` : task.agentId),
        agentId: groupId,
        routeId: task.routeId,
        taskId: task.id,
        className: className,
        title: isGeoTask ? this.bringozTimelineService.getGeoTaskTimelineItemTooltip(task, taskEtaWindow, relations, taskIndex) :
          (isItineraryTask ?
          this.bringozTimelineService.getItineraryTaskOrientedTimelineItemTooltip(task, taskEtaWindow, relations, taskIndex) :
          this.bringozTimelineService.getRouteTaskOrientedTimelineItemTooltip(task, taskEtaWindow, undefined, taskIndex)),
        content: isPoint ? this._getPointContent(task, color, taskIndex) : this._getTaskContent(task, taskIndex),
        // content: isItineraryTask ?
        //   (!isBundle ? this.bringozTimelineService.getTaskTimelineItemContent(task, relations, true, taskIndex) : this.bringozTimelineService.getBundleTaskTimelineItemContent(task, relations, true, taskIndex)) : (isPoint ? this.bringozTimelineService.getRouteInternalItemContent(task, true) :
        //   (isBundle ? this.bringozTimelineService.getRouteBundleTaskTimelineItemContent(task, relations, true, taskIndex) : this.bringozTimelineService.getRouteTaskTimelineItemContent(task, relations, true, taskIndex))),
        style: style,
      }
    });
  }

  private _initTimelineData(agents) {
    const groups = this._getGroupsData(agents);

    this.groupsDataSet.add(groups);
  }

  private _onClicked() {
    const deferred = this.$q.defer();
    deferred.resolve();
    return deferred.promise;
  }

  private _getSelectedItem(id) {

    if (!id) {
      return undefined;
    }

    const selectedItem = this.itemsDataSet.get({
      filter: (item) => {
        return item.id === id;
      }
    });
    return this.itemsDataSet.get(selectedItem[0] ? selectedItem[0].id : undefined)
  }

  private _setExpandedGroupsRoutes() {
    const updatedGroups = [];

    this.groupsDataSet.forEach((group) => {
      group.showNested = true;
      updatedGroups.push(group);
    });

    this.groupsDataSet.update(updatedGroups);
  }

  private _toggleGroupRoutes(groupId) {
    const updatedGroups = [];

    this.groupsDataSet.forEach((group) => {
      if (group.id === groupId) {
        group.showNested = !group.showNested;
      }
      updatedGroups.push(group);
    });

    this.groupsDataSet.update(updatedGroups);
  }

  private _clearTasksItems(ids?) {
    const itemsToClear = [];
    this.itemsDataSet.forEach((item) => {
      if (!ids || _.includes(ids, item.id)) {
        itemsToClear.push(item.id);
      }
    });
    this.itemsDataSet.remove(itemsToClear);
  }

  private _getRoutesGroup(a, index) {
    const isEven = (index % 2) === 0;
    let className = 'group-row br-caption-2';
    className += !!isEven ? ' even' : ' odd';

    // const groupColor = this.CommonsService.getColorById(a.id);
    const groupColor = this.colorPallet[index];
    return {
      id: a.id,
      name: this.$filter('userName')(a.user),
      nameInitials: this.$filter('userInitials')(a.user),
      avatarUrl: a.user.avatarUrl,
      agentType: this.$filter('translate')(`AGENT_TYPES.${a.agentType}`),
      agentStatus: a.status,
      skills: a.skills,
      className: className,
      ref: a,
      nestedGroups: ['geo-' + a.id, 'itinerary-' + a.id],
      showNested: true,
      style: 'border-left: ' + `15px solid ${groupColor}`
    }
  }

  private _getGeoGroup(a, index) {
    const isEven = (index % 2) === 0;
    // const groupColor = this.CommonsService.getColorById(a.id);
    const groupColor = this.colorPallet[index];
    return {
      isGeo: true,
      ref: a,
      id: 'geo-' + a.id,
      className: !!isEven ? 'even' : 'odd',
      skills: a.skills,
      style: 'border-left: ' + `15px solid ${groupColor}`
    }
  }

  private _getItineraryGroup(a, index) {
    const isEven = (index % 2) === 0;
    // const groupColor = this.CommonsService.getColorById(a.id);
    const groupColor = this.colorPallet[index];
    return {
      isItinerary: true,
      ref: a,
      id: 'itinerary-' + a.id,
      className: !!isEven ? 'even' : 'odd',
      skills: a.skills,
      style: 'border-left: ' + `15px solid ${groupColor}`
    }
  }

  private _getPointContent(task, color, taskIndex) {
    const purpose = task.taskSpec.purpose;

    const accountName = _.get(task, 'accountReference.name');
    // const accountText = accountName.replace(/[^a-z]/gi, '');
    let accountInitialsMatches = accountName.match(/\b(\w)/g) || accountName.match(/[\s]*(\S)+[\s]*/g) || [];
    accountInitialsMatches = _.filter(accountInitialsMatches, (s) => {
      return !/\d/.test(s);
    })
    const accountInitials = accountInitialsMatches.join('');
    let accountNumbers = accountName.replace(/\s*\(.*?\)\s*/g, '');
    accountNumbers = accountNumbers.replace(/[^0-9]/g,"");

    const label = purpose !== 'Pickup' ? (accountInitials ? (accountInitials + accountNumbers) : accountName) : this.$filter('translate')(purpose.charAt(0));


    // if (purpose !== 'Pickup') {
    //   return '<span class="br-body-2 font-weight-400 ' + label + '">' + accountInitials ? (accountInitials + accountNumbers) : accountName + '</span>'
    //     + '<div class="dot" style="' + `background: ${color}` + '"></div>'
    // } else {
    //   return '<span class="br-body-2 font-weight-400 ' + label + '">' + label + '</span>'
    //     + '<div class="dot" style="' + `background: ${color}` + '"></div>'
    // }

    return '<span class="br-body-2 font-weight-400 ' + label + '">' + label + '</span>'
      + '<div class="dot" style="' + `background: ${color}` + '"></div>'

  }

  private _getTaskContent(task, taskIndex) {
    const accountName = _.get(task, 'accountReference.name');
    // const accountText = accountName.replace(/[^a-z]/gi, '');
    let accountInitialsMatches = accountName.match(/\b(\w)/g) || accountName.match(/[\s]*(\S)+[\s]*/g) || [];
    accountInitialsMatches = _.filter(accountInitialsMatches, (s) => {
      return !/\d/.test(s);
    })
    const accountInitials = accountInitialsMatches.join('');
    let accountNumbers = accountName.replace(/\s*\(.*?\)\s*/g, '');
    accountNumbers = accountNumbers.replace(/[^0-9]/g,"");

    const purpose = task.taskSpec.purpose;
    const status = task.status;
    let statusIndication = document.createElement('div');
    statusIndication.classList.add('status-container', status);

    if (purpose !== 'Pickup') {
      return `<span class="br-caption-2 margin-right-5">${accountInitials ? (accountInitials + accountNumbers) : accountName}</span>
            <div class="item-status-container">${statusIndication.outerHTML}</div>`
    } else {
      return `<span class="br-caption-2 margin-right-5">${this.$filter('translate')(purpose.charAt(0))}</span>
            <div class="item-status-container">${statusIndication.outerHTML}</div>`
    }
  }

  $onDestroy() {
    if (this.timeline) {
      this.timeline.destroy();
      this.timeline = null;
    }
    if (this.itemsDataSet) {
      this.itemsDataSet.clear();
      this.itemsDataSet = null;
    }
    if (this.groupsDataSet) {
      this.groupsDataSet.clear();
      this.groupsDataSet = null;
    }
  }

}

angular
  .module('bringoz.admin.reports')
  .component('reportsSisenceAgentsTimeline', {
      bindings: {
        agents: '<',
        tasks: '<',
        date: '<',
        isStack: '<?',
        colorByLate: '<?',
        selectedItemId: '<',
        onViewService: '&',
        onRightClickTask: '&',
      },

      template: require('./reports-sisence-agents-timeline.html').default,
      controller: ReportsSisenceAgentsTimelineComponent
    }
  );
